import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import student from './modules/student'

Vue.use(Vuex)

/**
 * @description Vuex状态管理配置
 */
export default new Vuex.Store({
  modules: {
    user,
    student
  }
})
